// Broker identity for the signed-in workspace (business name, broker name, signature…). Cached per session.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;

export const FALLBACK = { first_name: '', full_name: '', business_name: '', email: '', phone: '', website: '', acl: '', credit_rep: '', logo_url: '', sms_signoff: '', email_signature: '' };

export const invalidateBranding = () => { cache = null; inflight = null; };

export function useBranding() {
  const { token } = useAuth();
  const [b, setB] = useState(cache || FALLBACK);
  useEffect(() => {
    if (!token) return;
    if (cache) { setB(cache); return; }
    inflight = inflight || axios.get(`${API}/api/branding/me`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => { cache = { ...FALLBACK, ...r.data.identity, variables: r.data.variables }; return cache; }).catch(() => FALLBACK);
    inflight.then((v) => setB(v));
  }, [token]);
  return b;
}

export const brandLine = (b) => [b.business_name, b.acl ? `Australian Credit Licence ${b.acl}` : null].filter(Boolean).join(' · ');
